var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.f{fill:#53c789;}.c{opacity:0.198;}.e{fill:#1f0256;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 240,
    height: 240,
    transform: "translate(538 247)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-538 -247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(538 247)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 120,
    cy: 120,
    r: 120,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.008 75.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2235.829,948.1l65.561,37.852L2405.16,926.04l-29.491-17.027L2301.389,951.9l-36.32-20.969Z",
    transform: "translate(-2235.737 -909.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2235.721,985.492l65.652,37.9V992.8l-65.652-37.9Z",
    transform: "translate(-2235.721 -915.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2312.887,1019.537l103.771-59.912v-30.6l-103.771,59.912Z",
    transform: "translate(-2247.235 -911.999)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.69018a8530a314e0a54d7e330bc7d1b0.svg";
export { ForwardRef as ReactComponent };